module.exports = __webpack_public_path__ + "static/media/mg.14910774.svg";